// Re-export for existing import sites. Firebase ID tokens carry the claims the
// backend needs, so no scopes are required.
export { loginRequest } from '../auth/firebaseMsalCompat';

// TODO: pass these vars from github environment variables and secrets?
export const getInsightsConnectionString = () => {
  const { hostname } = window.location;
  if (hostname === 'localhost') {
    return 'InstrumentationKey=ca1dc275-b8cf-415f-a3ec-ee06ae95b0c5;IngestionEndpoint=https://centralus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://centralus.livediagnostics.monitor.azure.com/;ApplicationId=20ec86b0-a379-4f25-b4a0-2323424cc460';
  } else if (hostname === 'pineapplemusiclab.com') {
    return 'InstrumentationKey=6e1034ec-bf71-40c3-b3b7-2c74b3f1aff1;IngestionEndpoint=https://centralus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://centralus.livediagnostics.monitor.azure.com/;ApplicationId=8c5b7820-e6a8-4476-8319-aa46aece8041';
  } else {
    return 'InstrumentationKey=ac680dfe-5d04-42db-a8e9-615c6762744c;IngestionEndpoint=https://centralus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://centralus.livediagnostics.monitor.azure.com/;ApplicationId=27d1cde1-36b9-4101-aa56-142cb781a198';
  }
};
